<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { __ } from '@oat-sa-private/ui-core';

    /**
     * A11y component. Only appears when focused by the keyboard. For use at the top and bottom of the document.
     */

    /**
     * @typedef {Object} Props
     * @property {Boolean} [isTop]
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        isTop = true
    } = $props();

    let hasFocus = $state(false);

    function handleFocus() {
        hasFocus = true;
    }

    function handleBlur() {
        hasFocus = false;
    }
</script>

<style>
    .focus-sentinel {
        position: absolute;
        left: -9999px;
        width: 100%;
        padding: 0.5rem 2rem;
        background: rgba(0, 0, 0, 0.7);
        color: var(--color-text-inverted);
        text-align: center;
        z-index: var(--layer-5);

        &:focus-visible {
            left: 0;
        }
        &.top {
            top: 0;
        }
        &.bottom {
            bottom: 0;
        }
    }
</style>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<div
    class="focus-sentinel"
    class:top={isTop}
    class:bottom={!isTop}
    tabindex="0"
    onfocus={handleFocus}
    onblur={handleBlur}>
    {#if hasFocus}
        <span>
            {__('You are about to leave the document and the test will be paused.')}
            {#if isTop}
                {__('Press Tab to keep focus within the document and resume the test.')}
            {:else}
                {__('Press Shift+Tab to keep focus within the document and resume the test.')}
            {/if}
        </span>
    {/if}
</div>
